module.exports = __webpack_public_path__ + "static/media/delete_button.1ca70189.png";


//////////////////
// WEBPACK FOOTER
// ./src/delete_button.png
// module id = 393
// module chunks = 0